import { StackToolbarButton } from './StackToolbarButton';
import StackToolbar from './StackToolbarClient';
import { StackToolbarMenu, StackToolbarMenuAction } from './StackToolbarMenu';
import { StackToolbarSearchBarSlot } from './StackToolbarSearchBarSlot';
import { StackToolbarSpacer } from './StackToolbarSpacer';
import { StackToolbarView } from './StackToolbarView';
import { StackToolbarBadge, StackToolbarIcon, StackToolbarLabel } from './toolbar-primitives';

StackToolbar.Button = StackToolbarButton;
StackToolbar.Menu = StackToolbarMenu;
StackToolbar.MenuAction = StackToolbarMenuAction;
StackToolbar.SearchBarSlot = StackToolbarSearchBarSlot;
StackToolbar.Spacer = StackToolbarSpacer;
StackToolbar.View = StackToolbarView;
StackToolbar.Label = StackToolbarLabel;
StackToolbar.Icon = StackToolbarIcon;
StackToolbar.Badge = StackToolbarBadge;

export { StackToolbar };
